import { UNHASHABLE_IDS } from '../config/constants';
import getBrowser from '../getters/get-browser';
import getLanguage from '../getters/get-language';
import { getISOTime } from '../getters/get-time-stamp';
import { hashByConfig } from '../helpers/hash-by-config';
import { updateCustomIdentifiers } from '../helpers/update-custom-identifiers';

/**
 * Структура настроек мета-информации для пакета событий
 */

/**
* Блок данных о приложении, устройстве и пакете отправленных данных
*/

const meta = {};

/**
 * Установка настроек мета-параметров для пакета событий
 * @param {Profile} profile объект настроек мета-параметров
 * @return {void}
 */
export const setMeta = nextMeta => {
  Object.assign(meta, nextMeta);
};
/**
 * Совокупность методов установки специфичных параметров мета-параметров
 */
export const metaUpdater = {
  /**
   * Установка SbAppId
   * @param {String} value значение SbAppID
   * @param {Boolean} enableHash признак хэширования
   * @return {MetaUpdater} metaUpdater
   */
  setSbAppID(value, enableHash) {
    updateCustomIdentifiers({
      entity: meta,
      key: 'sbApplicationId',
      value: hashByConfig(value, enableHash)
    });
    return this;
  },
  /**
   * Установка значения некоторого идентификатора в meta
   * @param {String} key ключ идентификатора
   * @param {String} value значение идентификатора
   * @param {Boolean} enableHash признак хэширования. Для staticId, idfa, gaid всегда нет хеширования
   * @return {MetaUpdater} metaUpdater
   */
  setMetaID(key, value, enableHash) {
    updateCustomIdentifiers({
      entity: meta,
      key,
      value: hashByConfig(value, UNHASHABLE_IDS.includes(key) ? false : enableHash)
    });
    return this;
  }
};
export const getMeta = () => {
  return {
    ...meta,
    platform: 'WEB',
    screenSize: globalThis.screen ? `${globalThis.screen.width}x${globalThis.screen.height}` : void 0,
    browser: getBrowser(),
    systemLanguage: getLanguage(),
    timeStamp: getISOTime()
  };
};